export const isModuleLoadError = (e: string | null) =>
  !!e?.match(/dynamically imported module/i)
